// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  text-align: center;
  padding: 24px 0 32px 0;
  max-width: 1200px;
  margin: 0 auto;
}
.heading > ds-text {
  display: block;
}
.heading > ds-text:first-of-type {
  padding-bottom: 16px;
}
.heading .buttons-header {
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 576px) {
  .heading .buttons-header {
    justify-content: center;
    margin-top: 8px;
  }
}
.heading .buttons-header .button-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.heading .buttons-header .zurueck ds-icon {
  margin-right: 15px;
}
.heading .buttons-header .weiter ds-icon {
  margin-left: 15px;
}

.main-content {
  padding-bottom: 128px;
}

.main-content,
ds-modal {
  max-width: 1200px;
  margin: 0 auto;
}
.main-content .card-container,
.main-content .modal-content,
ds-modal .card-container,
ds-modal .modal-content {
  padding: 16px;
}
@media (min-width: 576px) {
  .main-content .card-container.modal-content,
  .main-content .modal-content.modal-content,
  ds-modal .card-container.modal-content,
  ds-modal .modal-content.modal-content {
    min-width: 650px;
    padding: 16px;
  }
}
@media (max-width: 576px) {
  .main-content .card-container.modal-content,
  .main-content .modal-content.modal-content,
  ds-modal .card-container.modal-content,
  ds-modal .modal-content.modal-content {
    overflow-y: scroll;
    max-height: 60vh;
  }
}
.main-content .card-container .text-aligner,
.main-content .modal-content .text-aligner,
ds-modal .card-container .text-aligner,
ds-modal .modal-content .text-aligner {
  display: flex;
  align-items: flex-start;
  margin-top: 7px;
  margin-bottom: -20px;
}
@media (min-width: 768px) {
  .main-content .card-container .text-aligner,
  .main-content .modal-content .text-aligner,
  ds-modal .card-container .text-aligner,
  ds-modal .modal-content .text-aligner {
    margin-bottom: 0;
  }
}
.main-content .card-container .text-aligner.margin-for-text,
.main-content .modal-content .text-aligner.margin-for-text,
ds-modal .card-container .text-aligner.margin-for-text,
ds-modal .modal-content .text-aligner.margin-for-text {
  margin-bottom: 0;
}
.main-content .card-container .margin-bottom-24,
.main-content .modal-content .margin-bottom-24,
ds-modal .card-container .margin-bottom-24,
ds-modal .modal-content .margin-bottom-24 {
  margin-bottom: 24px;
}
.main-content .card-container .margin-bottom-56,
.main-content .modal-content .margin-bottom-56,
ds-modal .card-container .margin-bottom-56,
ds-modal .modal-content .margin-bottom-56 {
  margin-bottom: 56px;
}
.main-content .card-container .input-wrapper,
.main-content .modal-content .input-wrapper,
ds-modal .card-container .input-wrapper,
ds-modal .modal-content .input-wrapper {
  width: 262px;
}
.main-content .card-container .card-header,
.main-content .modal-content .card-header,
ds-modal .card-container .card-header,
ds-modal .modal-content .card-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.main-content .card-container .card-angebot-content,
.main-content .modal-content .card-angebot-content,
ds-modal .card-container .card-angebot-content,
ds-modal .modal-content .card-angebot-content {
  display: flex;
  flex-direction: column;
}
.main-content .card-container .card-angebot-content.unfall-table-content,
.main-content .modal-content .card-angebot-content.unfall-table-content,
ds-modal .card-container .card-angebot-content.unfall-table-content,
ds-modal .modal-content .card-angebot-content.unfall-table-content {
  overflow-x: scroll;
  overflow-y: hidden;
}
.main-content .card-container .card-angebot-content .leistungsuebersicht-button,
.main-content .modal-content .card-angebot-content .leistungsuebersicht-button,
ds-modal .card-container .card-angebot-content .leistungsuebersicht-button,
ds-modal .modal-content .card-angebot-content .leistungsuebersicht-button {
  padding-top: 32px;
}
.main-content .card-container .card-angebot-content table,
.main-content .modal-content .card-angebot-content table,
ds-modal .card-container .card-angebot-content table,
ds-modal .modal-content .card-angebot-content table {
  border-spacing: 0;
}
.main-content .card-container .card-angebot-content table tr:last-child td,
.main-content .card-container .card-angebot-content table tr:first-child td,
.main-content .modal-content .card-angebot-content table tr:last-child td,
.main-content .modal-content .card-angebot-content table tr:first-child td,
ds-modal .card-container .card-angebot-content table tr:last-child td,
ds-modal .card-container .card-angebot-content table tr:first-child td,
ds-modal .modal-content .card-angebot-content table tr:last-child td,
ds-modal .modal-content .card-angebot-content table tr:first-child td {
  border-bottom: none;
}
.main-content .card-container .card-angebot-content table td,
.main-content .modal-content .card-angebot-content table td,
ds-modal .card-container .card-angebot-content table td,
ds-modal .modal-content .card-angebot-content table td {
  padding: 12px 32px 12px 0;
  border-bottom: 1px solid #c1c1c1;
}
.main-content .card-container .card-angebot-content table td .name-wrapper,
.main-content .modal-content .card-angebot-content table td .name-wrapper,
ds-modal .card-container .card-angebot-content table td .name-wrapper,
ds-modal .modal-content .card-angebot-content table td .name-wrapper {
  display: flex;
  flex-direction: column;
}
@media (min-width: 992px) {
  .main-content .card-container .card-angebot-content table td.td-name, .main-content .card-container .card-angebot-content table td.td-rentenvariante,
  .main-content .modal-content .card-angebot-content table td.td-name,
  .main-content .modal-content .card-angebot-content table td.td-rentenvariante,
  ds-modal .card-container .card-angebot-content table td.td-name,
  ds-modal .card-container .card-angebot-content table td.td-rentenvariante,
  ds-modal .modal-content .card-angebot-content table td.td-name,
  ds-modal .modal-content .card-angebot-content table td.td-rentenvariante {
    white-space: nowrap;
  }
}
.main-content .buttons-container,
ds-modal .buttons-container {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  margin-right: 24px;
}
@media (max-width: 576px) {
  .main-content .buttons-container,
  ds-modal .buttons-container {
    justify-content: center;
  }
}
.main-content .buttons-container .col-buttons,
ds-modal .buttons-container .col-buttons {
  display: flex;
  align-items: center;
}
@media (max-width: 576px) {
  .main-content .buttons-container .col-buttons,
  ds-modal .buttons-container .col-buttons {
    flex-direction: column;
  }
}
.main-content .buttons-container .col-buttons .button-secondary,
ds-modal .buttons-container .col-buttons .button-secondary {
  margin-right: 24px;
}
@media (max-width: 576px) {
  .main-content .buttons-container .col-buttons .button-secondary,
  ds-modal .buttons-container .col-buttons .button-secondary {
    margin-right: 0;
    margin-bottom: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/angebot-bearbeiten/angebot-bearbeiten.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AADF;AAGE;EACE,cAAA;AADJ;AAGI;EACE,oBAAA;AADN;AAKE;EACE,eAAA;EACA,aAAA;EACA,8BAAA;AAHJ;AAKI;EALF;IAMI,uBAAA;IACA,eAAA;EAFJ;AACF;AAII;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAFN;AAMM;EACE,kBAAA;AAJR;AASM;EACE,iBAAA;AAPR;;AAaA;EACE,qBAAA;AAVF;;AAaA;;EAEE,iBAAA;EACA,cAAA;AAVF;AAYE;;;;EAEE,aAAA;AARJ;AAWM;EADF;;;;IAEI,gBAAA;IACA,aAAA;EALN;AACF;AAOM;EANF;;;;IAOI,kBAAA;IACA,gBAAA;EADN;AACF;AAII;;;;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AACN;AACM;EANF;;;;IAOI,gBAAA;EAKN;AACF;AAHM;;;;EACE,gBAAA;AAQR;AAJI;;;;EACE,mBAAA;AASN;AANI;;;;EACE,mBAAA;AAWN;AARI;;;;EACE,YAAA;AAaN;AAVI;;;;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAeN;AAZI;;;;EACE,aAAA;EACA,sBAAA;AAiBN;AAfM;;;;EACE,kBAAA;EACA,kBAAA;AAoBR;AAjBM;;;;EACE,iBAAA;AAsBR;AAnBM;;;;EACE,iBAAA;AAwBR;AApBU;;;;;;;;EACE,mBAAA;AA6BZ;AAzBQ;;;;EACE,yBAAA;EACA,gCAAA;AA8BV;AA5BU;;;;EACE,aAAA;EACA,sBAAA;AAiCZ;AA9BU;EACE;;;;;;;IAEE,mBAAA;EAqCZ;AACF;AA9BE;;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAiCJ;AA/BI;EANF;;IAOI,uBAAA;EAmCJ;AACF;AAjCI;;EACE,aAAA;EACA,mBAAA;AAoCN;AAlCM;EAJF;;IAKI,sBAAA;EAsCN;AACF;AApCM;;EACE,kBAAA;AAuCR;AAtCQ;EAFF;;IAGI,eAAA;IACA,kBAAA;EA0CR;AACF","sourcesContent":["@import \"../../styles/variables\";\n\n.heading {\n  text-align: center;\n  padding: 24px 0 32px 0;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  > ds-text {\n    display: block;\n\n    &:first-of-type {\n      padding-bottom: 16px;\n    }\n  }\n\n  .buttons-header {\n    padding: 0 16px;\n    display: flex;\n    justify-content: space-between;\n\n    @media (max-width: $DVAG-breakpoint-SM) {\n      justify-content: center;\n      margin-top: 8px;\n    }\n\n    .button-container {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n    }\n\n    .zurueck {\n      ds-icon {\n        margin-right: 15px;\n      }\n    }\n\n    .weiter {\n      ds-icon {\n        margin-left: 15px;\n      }\n    }\n  }\n}\n\n.main-content {\n  padding-bottom: 128px;\n}\n\n.main-content,\nds-modal {\n  max-width: 1200px;\n  margin: 0 auto;\n\n  .card-container,\n  .modal-content {\n    padding: 16px;\n\n    &.modal-content {\n      @media (min-width: $DVAG-breakpoint-SM) {\n        min-width: 650px;\n        padding: 16px;\n      }\n\n      @media (max-width: $DVAG-breakpoint-SM) {\n        overflow-y: scroll;\n        max-height: 60vh;\n      }\n    }\n\n    .text-aligner {\n      display: flex;\n      align-items: flex-start;\n      margin-top: 7px;\n      margin-bottom: -20px;\n\n      @media (min-width: $DVAG-breakpoint-MD) {\n        margin-bottom: 0;\n      }\n\n      &.margin-for-text {\n        margin-bottom: 0;\n      }\n    }\n\n    .margin-bottom-24 {\n      margin-bottom: 24px;\n    }\n\n    .margin-bottom-56 {\n      margin-bottom: 56px;\n    }\n\n    .input-wrapper {\n      width: 262px;\n    }\n\n    .card-header {\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n    }\n\n    .card-angebot-content {\n      display: flex;\n      flex-direction: column;\n\n      &.unfall-table-content {\n        overflow-x: scroll;\n        overflow-y: hidden;\n      }\n\n      .leistungsuebersicht-button {\n        padding-top: 32px;\n      }\n\n      table {\n        border-spacing: 0;\n\n        tr:last-child,\n        tr:first-child {\n          td {\n            border-bottom: none;\n          }\n        }\n\n        td {\n          padding: 12px 32px 12px 0;\n          border-bottom: 1px solid $DVAG-color-dunkelgrau-70;\n\n          .name-wrapper {\n            display: flex;\n            flex-direction: column;\n          }\n\n          @media (min-width: $DVAG-breakpoint-LG) {\n            &.td-name,\n            &.td-rentenvariante {\n              white-space: nowrap;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .buttons-container {\n    display: flex;\n    justify-content: flex-end;\n    padding: 16px;\n    margin-right: 24px;\n\n    @media (max-width: $DVAG-breakpoint-SM) {\n      justify-content: center;\n    }\n\n    .col-buttons {\n      display: flex;\n      align-items: center;\n\n      @media (max-width: $DVAG-breakpoint-SM) {\n        flex-direction: column;\n      }\n\n      .button-secondary {\n        margin-right: 24px;\n        @media (max-width: $DVAG-breakpoint-SM) {\n          margin-right: 0;\n          margin-bottom: 8px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
